// extracted by mini-css-extract-plugin
export var arrow = "_27-6";
export var changeItem = "_27-3";
export var changesHeader = "_27-1";
export var changesList = "_27-2";
export var container = "_27-0";
export var pathLabel = "_27-4";
export var value = "_27-7";
export var valuesContainer = "_27-5";